import { useRef, useEffect, useState } from "react";
import { PanelNav } from "../Bootoverlay/Bootoverlay";

// ─── STATS (6 items + Reserve Kart = 7th cell) ──────
const STATS = [
  { label: "PLATFORM", val: "DF GOBLIN" },
  { label: "ENGINE", val: "COBALT I4" },
  { label: "WEIGHT", val: "1,200", unit: "LBS" },
  { label: "CONFIG", val: "MID-ENGINE RWD" },
  { label: "BODY", val: "OPEN COCKPIT" },
  { label: "LICENSE", val: "VALID DL", color: "blue" },
  { label: "STATUS", val: "STREET LEGAL", color: "lime" },
];

// ─── PANEL KART ───────────────────────────────────────
export default function PanelKart({ onNav }) {
  return (
    <section className="vk-panel" id="panel-kart">
      <div className="vk-kart-bg" aria-hidden="true">
        <div className="vk-kart-glow-bg" />
        <div className="vk-kart-grid-lines" />
      </div>

      <div className="vk-kart-screen">
        <div className="vk-kart-top">

          {/* LEFT: Text + Stats + CTA + Nav */}
          <div className="vk-kart-left vk-enter-child">
            <div className="vk-section-eyebrow">
              <span className="vk-eyebrow-num">03</span>
              <span>//</span>
              <span>VEHICLE CLASS</span>
            </div>

            <h2 className="vk-section-title vk-kart-title" style={{ borderBottom: "none" }}>
              MEET YOUR<br />
              <span className="orange">STREET KART</span>
            </h2>

            <p className="vk-kart-desc">
              The DF Goblin. Mid-engine. Open cockpit. Street legal.
              Built on a Chevy Cobalt donor — transformed into an open-wheel
              street kart that puts
              you on the real streets of Las Vegas.
            </p>

            {/* Stats grid — 8 cells: 7 stats + 1 CTA button */}
            <div className="vk-stat-grid-v2">
              {STATS.map((s, i) => (
                <div className="vk-stat-card-v2" key={i}>
                  <div className="vk-stat-label">{s.label}</div>
                  <div className={`vk-stat-value ${s.color || ""}`}>
                    {s.val}
                    {s.unit && <span className="vk-stat-unit"> {s.unit}</span>}
                  </div>
                </div>
              ))}

            </div>
                <button
                  className="vk-btn-primary vk-kart-cta-inline"
                  onClick={() => onNav(3)}
                  style={{ width: "100%", minHeight: "52px",display:"flex",justifyContent:"center",marginTop:"20px"}}
                >
                  <span>RESERVE KART ▶</span>
                </button>

            {/* Nav Carousel */}
            <div className="vk-left-nav-wrapper">
              <PanelNav prev={1} next={3} label="03 / 08 — VEHICLE" onNav={onNav} />
            </div>
          </div>

          {/* RIGHT COLUMN: Image */}
          <div className="vk-kart-right vk-enter-child">
            <div className="vk-kart-img-wrapper">
              <img
                src="/images/3d_image.png"
                alt="DF Goblin Street Kart"
                className="vk-kart-img"
              />
              <div className="vk-kart-reticle" aria-hidden="true">
                <div className="vk-ret-corner vk-ret-tl" />
                <div className="vk-ret-corner vk-ret-tr" />
                <div className="vk-ret-corner vk-ret-bl" />
                <div className="vk-ret-corner vk-ret-br" />
              </div>
            </div>
          </div>

        </div>
      </div>
    </section>
  );
}